"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var submit_button_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/submit_page_footer/submit_button"));
var annotation_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/submit_page_footer/annotation"));
var recommended_store_list_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/import_category_based/recommended_store_list"));
var hikakaku_estimateform_zero_sorry1_png_1 = __importDefault(require("@hikakaku/shared/images/hikakaku-estimateform_zero_sorry1.png"));
var UserPageFooter = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        store.doesNotHaveAnyExpectedStore &&
            react_1.default.createElement("div", { className: "estimateForm-SubmitPageFooter_NoStoreImageWrapper" },
                react_1.default.createElement("img", { src: hikakaku_estimateform_zero_sorry1_png_1.default, alt: "HikakakuImage", className: "estimateForm-SubmitPageFooter_NoStoreImage lazyload" })),
        store.showsExpectedStoreCounts &&
            react_1.default.createElement("div", { className: "estimateForm-SubmitPageFooter_ExpectedStoreCounts" },
                store.expectedStoreCounts
                    .map(function (_a, idx) {
                    var label = _a.label, count = _a.count;
                    return (react_1.default.createElement("span", { key: idx },
                        react_1.default.createElement("span", { className: "estimateForm-SubmitPageFooter_StoreCountLabel" },
                            "\u300E",
                            label,
                            "\u300F"),
                        "\u3092\u8FFD\u52A0\u3059\u308B\u3068",
                        react_1.default.createElement("span", { className: "estimateForm-SubmitPageFooter_StoreCountNumber" }, count),
                        "\u793E"));
                })
                    .reduce(function (acc, elt) { return [acc, '、', elt]; }),
                "\u67FB\u5B9A\u4F9D\u983C\u696D\u8005\u304C\u5897\u3048\u307E\u3059\uFF01"),
        store.doesRecommendPurchaseMethod &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "estimateForm-SubmitPageFooter_Annotation estimateForm-SubmitPageFooter_Annotation-warn" },
                    react_1.default.createElement("i", { className: "fa fa-exclamation-circle" }),
                    store.submitButtonAnnotationText),
                react_1.default.createElement("input", { type: "hidden", name: "estimate_form[user][purchase_method][]", value: store.recommendedPurchaseMethod })),
        react_1.default.createElement(submit_button_1.default, { onClick: store.handleClickSubmitButton, disabled: !store.isSubmitButtonEnabled, text: store.submitButtonText, className: store.submitButtonClassNames }),
        react_1.default.createElement(annotation_1.default, null),
        store.doesNotHaveAnyExpectedStore && store.recommendedStores &&
            react_1.default.createElement(recommended_store_list_1.default, { recommendedStores: store.recommendedStores }),
        react_1.default.createElement("button", { onClick: store.handleClickPrevButton, className: "estimateForm-SubmitPageFooter_PrevButton" }, "\u623B\u308B")));
});
exports.default = UserPageFooter;
